import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      document.querySelectorAll( '[data-component="tree-ring-graphic"]' ).forEach( ( graphic ) => {
        if ( graphic.classList.contains( 'is-animated' ) ) {
          return;
        }

        const rings = graphic.querySelectorAll( '.tree-ring-graphic__ring' );
        const transformOrigin = graphic.dataset.ringOrigin || 'center center';

        if ( !rings.length ) {
          return;
        }

        graphic.classList.add( 'is-animated' );

        if ( !window.hasMotion ) {
          gsap.set( rings, {clearProps: 'all'} );
          return;
        }

        gsap.set( rings, {
          scale: 0.08,
          transformOrigin,
        } );

        const timeline = gsap.timeline( {
          scrollTrigger: {
            trigger: graphic,
            start: 'top 88%',
            once: true,
          },
        } );

        rings.forEach( ( ring, index ) => {
          const direction = index % 2 === 0 ? 1 : -1;

          timeline.to( ring, {
            keyframes: [
              {
                scale: 0.55,
                rotation: direction * 0.45,
                duration: 0.65,
                ease: 'sine.in',
              },
              {
                scale: 1.001,
                rotation: direction * 0.18,
                duration: 1 + ( index % 3 ) * 0.1,
                ease: 'sine.out',
              },
              {
                scale: 1,
                rotation: 0,
                duration: 0.55,
                ease: 'sine.inOut',
              },
            ],
          }, index * 0.25 );
        } );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'tree-ring-graphic', COMPONENT );
} )( app );
